import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';

import { AuthService } from '@services/auth.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
    resetForm: UntypedFormGroup;
    isLoading: boolean;
    resetPasswordSent: boolean;

    constructor(
        private authSrv: AuthService,
        private fb: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.initForm();
    }

    onSubmit() {
        this.isLoading = true;

        this.authSrv.requestPasswordReset(this.resetForm.value.username)
        .subscribe(() => {
            this.isLoading = false;
            this.resetPasswordSent = true;
        });
    }

    private initForm() {
        this.resetForm = this.fb.group({
            username: ['', [Validators.required]]
        });
    }
}
